<template>
	<div class="info-form-cls">
		<section class="context-cls">
			<el-form labelPosition="top" autoComplete="on" :model="customerForm" ref="customerForm" :inline="true">
				<div class="cell">
					<el-form-item label="沟通方向：">
						<el-input :value="row.direction === 'IB' ? '来访' : '出访'" size="small" disabled></el-input>
					</el-form-item>
				</div>
				<div class="cell">
					<el-form-item label="渠道：">
						<el-input :value="row.channelName" size="small" disabled></el-input>
					</el-form-item>
				</div>
				<div class="cell">
					<el-form-item label="开始时间：">
						<el-input :value="row.startTime" size="small" disabled></el-input>
					</el-form-item>
				</div>
				<div class="cell">
					<el-form-item label="结束时间：">
						<el-input :value="row.endTime" size="small" disabled></el-input>
					</el-form-item>
				</div>
				<div class="cell">
					<el-form-item label="执行坐席：">
						<el-input :value="row.csrUserName" size="small" disabled></el-input>
					</el-form-item>
				</div>
				<div class="cell" :class="{'width': ['text', 'file'].includes(item.displayMode)}" v-for="(item, index) in columnList" :key="index">
					<ComponentLibrary @emitMyCascader="emitMyCascader" :sourceType="sourceType" :itemData="item" :customerForm="customerForm" />
				</div>
			</el-form>
		</section>
		<el-divider></el-divider>
		<section style="text-align: center;" v-if="sourceType != 'historyInfo'">
			<el-button @click.stop="$emit('closeDialogFormVisible', false);" size="small">取 消</el-button>
			<el-button @click.stop="handleSave" :loading="loading" size="small" type="primary">保 存</el-button>
		</section>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import ComponentLibrary from 'components/CustomerInfo/Library';
export default {
	name: "AddFormCustomer",
	props: ['row', 'sourceType'],
	components: {ComponentLibrary},
	computed: {
        ...mapGetters([
			'userInfo',
        ])
    },
	data() {
		return {
			loading: false,
			phoneList: [1],
			columnList: [],
			customerForm: {},
		}
	},
	async created() {
		if (this.$refs["customerForm"]) {
			await this.$refs["customerForm"].resetFields();
		}
		await this.getDetailInfo();
	},
	methods: {
		getDetailInfo() {
			let self = this;
			self.$api.apiQueryCommunicateColumn({brand: self.userInfo.brandIdentify}).then(response => {
				if(response.errcode != 0) return;
				let keyArrayList = [];
				self.columnList = response.data;
				for(let item of self.columnList) {
					// const optionsJson = JSON.parse(item.optionsJson);
					// if(item.displayMode === 'checkbox') {
					// 	let columnNotNull = [];
					// 	for(const _item of optionsJson['data']) {
					// 		if(_item.columnNotNull === 'Y') {
					// 			columnNotNull.push(_item.value);
					// 		}
					// 	}
					// 	self.$set(self.customerForm, item.columnKey, columnNotNull);
						
					// } else if(['droplist', 'radio'].includes(item.displayMode)) {
					// 	let columnNotNull = null;
					// 	for(const _item of optionsJson['data']) {
					// 		if(_item.columnNotNull === 'Y') {
					// 			columnNotNull = _item;
					// 		}
					// 	}
					// 	self.$set(self.customerForm, item.columnKey, columnNotNull ? columnNotNull.value : '');
					// } else {
					// 	self.$set(self.customerForm, item.columnKey, '');
					// }
					if(item.displayMode === 'checkbox') {
						self.$set(self.customerForm, item.columnKey, []);
					} else {
						self.$set(self.customerForm, item.columnKey, '');
					}
					if(item.displayMode === 'checkbox' || item.displayMode === 'cascade') {
						keyArrayList.push(item.columnKey);
					}
				}
				self.$api.apiPostIncident({brandId: self.userInfo.brandIdentify, pageNumber: 1, pageSize: 1, tuid: self.row.tuid}).then(res => {
					if(res.errcode != 0) {
						return;
					}
					self.customerForm = Object.assign(self.customerForm, res.data?.[0], res.data?.[0]?.['customData']);
					Object.keys(self.customerForm).forEach((key) => {
						if(keyArrayList.includes(key)) {
							if(!Array.isArray(self.customerForm[key])) {
								self.customerForm[key] = self.customerForm[key] ? self.customerForm[key].split(',') : [];
							}
						} else if([undefined, null].indexOf(self.customerForm[key]) > -1) {
							self.customerForm[key] = '';
						}
					});
				});
			});
		},
		handleSave() {
			this.$refs["customerForm"].validate(valid => {
                if (valid) {
					this.loading = true;
					this.customerForm['tuid'] = this.row.tuid;
					this.customerForm['brandId'] = this.userInfo.brandIdentify;
                    this.$api.apiPostUpdateCommunicate(this.customerForm).then(response => {
						if(response.errcode != 0) {
							this.loading = false;
							return;
						}
						this.$notify({
							title: '保存成功',
							type: 'success'
						});
						this.loading = false;
						this.$emit('closeDialogFormVisible', true);
					});
                }
            });
		},
		emitMyCascader(obj) {
			this.customerForm = Object.assign(this.customerForm, obj);
		},
	}
}
</script>

<style lang="scss" scoped>
.info-form-cls {
	width: 100%;

	& > .context-cls {
		width: 100%;
		padding-bottom: 20px;
		box-sizing: border-box;
		width: 100%;
		height: 450px;
		overflow-x: hidden;
		overflow-y: auto;

		& .cell {
			display: inline-block;
			width: 50%;
			padding: 0 10px;
			box-sizing: border-box;
			vertical-align: top;

			&.width {
				width: 100%;
			}

			::v-deep .el-form-item {
				width: 100%;
				& > .el-form-item__label {
					padding: 0;
					line-height: 30px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				& .el-form-item__content {
					& .el-input, & .el-select, & .el-date-picker, & .el-input-number, & .el-cascader {
						vertical-align: top;
						display: inline-block;
						width: 100%;
					}

					& .el-input-number {
						margin-top: 2px;
					}

					& .el-upload, & .el-upload-dragger {
						width: 100%;
					}

					& .icon-cls {
						vertical-align: top;
						display: inline-block;
						font-size: 16px;
						margin: 0 12px;
						cursor: pointer;
						color: #000000;
						position: relative;
						top: 11px;
					}

					& .svg-icon {
						vertical-align: top;
						display: inline-block;
						width: 28px;
						height: 28px;
						cursor: pointer;
						position: relative;
						top: 4px;
					}

					& .el-radio-group {
						line-height: 48px;
					}
				}
			}
		}
	}
}
</style>
